export const cashInFilterState = () => ({
  startDate: null,
  endDate: null,
  searchKey: "",
  searchType: "cashinId",
  cashinChannel: "all",
  cashinStatus: "all",
  page: 1,
  perPage: 10,
});
